<template>
  <div
    class="card mb-3 border-0 shadow-sm custom-branch-card"
    :class="{'border-theme': branch.is_active}"
    :key="branch.branch_id"
  >
    <div class="bg-white border-bottom-0 card-header d-flex justify-content-between rounded-bottom">
      <div class="d-flex align-items-center">
        <div class="branch-icon me-3" :class="branch.is_active ? 'bg-theme text-white' : 'bg-light text-muted'">
          <i class="fa-solid fa-shop"/>
        </div>
        <div>
          <h6 class="mb-0 fw-bold" :class="{'text-theme': branch.is_active}">{{ branch.name }}</h6>
          <small class="text-muted" v-if="branch.code">{{ $t('Code') + ': ' + branch.code }}</small>
        </div>
      </div>
      <div class="form-check form-switch ms-3">
        <input
          class="form-check-input shadow-none"
          type="checkbox"
          v-model.trim="v$.branch.is_active.$model"
        >
      </div>
    </div>

    <div class="card-body bg-white pt-0 rounded-bottom" v-if="branch.is_active">
      <hr class="mt-0 mb-3 text-black-50">

      <label class="form-label small fw-semibold text-muted mb-2">{{ $t('Options') }}</label>
      <div class="table-responsive border rounded">
        <table class="table table-sm table-hover mb-0 align-middle">
          <thead class="table-light">
            <tr>
              <th style="min-width: 150px;">{{ $t('Options') }}</th>
              <th class="text-end" style="min-width: 130px;">{{ $t('Price') }} ({{ $t('฿') }})</th>
              <th class="text-center" style="min-width: 110px;">{{ $t('Stock Status') }}</th>
              <th class="text-center" style="min-width: 80px;">{{ $t('Active') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(option, oIndex) in branch.options"
              :key="option.id"
            >
              <td>
                <span class="fw-semibold">{{ $t(option.option_name) }}</span>
              </td>
              <td class="text-end px-2">
                <div v-if="!option.is_custom_price" class="d-flex align-items-center justify-content-end">
                  <input
                    type="text"
                    class="form-control form-control-sm text-end me-1 shadow-none"
                    style="width: 100px;"
                    :value="option.base_price"
                    disabled
                  >
                  <button
                    type="button"
                    class="btn btn-sm btn-light border py-1 px-2 text-theme"
                    @click="option.is_custom_price = true"
                  >
                    <i class="fa-solid fa-pen-to-square"/>
                  </button>
                </div>
                <div v-else class="d-flex align-items-center justify-content-end">
                  <input
                    type="number"
                    inputmode="decimal"
                    class="form-control form-control-sm fw-bold me-1 shadow-none text-end text-theme"
                    style="width: 100px;"
                    v-model.trim="option.price_override"
                    :placeholder="option.base_price"
                  >
                  <button
                    type="button"
                    class="btn btn-sm btn-light border text-danger py-1 px-2"
                    @click="option.is_custom_price = false; option.price_override = ''"
                  >
                    <i class="fa-solid fa-rotate-left"/>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <select
                  class="form-select form-select-sm shadow-none"
                  v-model="option.is_in_stock"
                >
                  <option :value="true">{{ $t('In Stock') }}</option>
                  <option :value="false">{{ $t('Out of Stock') }}</option>
                </select>
              </td>
              <td class="text-center">
                <div class="form-check form-switch d-flex justify-content-center">
                  <input
                    class="form-check-input shadow-none"
                    type="checkbox"
                    v-model="option.is_active"
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-branch-item";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.branch);
  },
  props: {
    branch: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true
    }
  }
}
</script>
